<mat-card data-at-serial-number-modal>
  <mat-card-header>
    <mat-card-title class="!flex flex-row justify-between items-center">
      <div>
        {{
          data.editBoilerSerial
            ? ('+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.BOILER_SERIAL_MODAL.TITLE' | translate)
            : ('+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.BMU_SERIAL_MODAL.TITLE' | translate)
        }}
      </div>
      <button
        data-at-close-serial-number-modal
        mat-icon-button
        gtm="onClose"
        gtmAction="Serial number"
        gtmCategory="editSerialNumberModal"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content
    class="!flex flex-row gap-[16px] justify-start items-center lt-md:flex-col lt-md:items-start"
  >
    <mat-form-field
      mat-input-height-large-label
      class="flex-1 lt-md:w-full"
      [class.error]="serialNumberControl.invalid"
    >
      <mat-label>{{ 'EDIT_SERIAL_NUMBER_MODAL.LABEL' | translate }}</mat-label>
      <input
        gtm="onTextField"
        gtmAction="Serial number"
        gtmCategory="editSerialNumberModal"
        [gtmOn]="['change', 'focus', 'blur']"
        data-at-serial-number-input
        matInput
        autocomplete="off"
        [formControl]="serialNumberControl"
        [errorStateMatcher]="matcher"
        fieldTextContentTooltip
      />
      <button
        *ngIf="serialNumberControl.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="onClear()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
      <mat-error *ngIf="serialNumberControl.hasError('required')">
        {{ 'EDIT_SERIAL_NUMBER_MODAL.ERROR_REQUIRED' | translate }}
      </mat-error>
      <mat-error *ngIf="serialNumberControl.hasError('pattern')">
        {{ 'EDIT_SERIAL_NUMBER_MODAL.ERROR_PATTERN' | translate }}
      </mat-error>
    </mat-form-field>
    <button
      *ngIf="!(data.editBoilerSerial && (codeScannerService.isCodeScannerAvailable$ | async))"
      class="save-btn w-[150px] lt-md:w-full"
      data-at-save-serial-number-modal
      mat-raised-button
      gtm="onSave"
      gtmAction="Serial number"
      gtmCategory="editSerialNumberModal"
      color="primary"
      [disabled]="!serialNumberControl.valid || !isSerialNumberChanged()"
      (click)="onSaveSerialNumber()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-content>
  <mat-card-actions
    *ngIf="data.editBoilerSerial && (codeScannerService.isCodeScannerAvailable$ | async)"
    class="!flex flex-col gap-[8px] justify-start items-center"
  >
    <button
      data-at-save-serial-number-modal
      mat-stroked-button
      gtm="onOpen"
      gtmAction="Barcode scanner"
      gtmCategory="editSerialNumberModal"
      color="primary"
      class="barcode-btn"
      (click)="openScanner()"
    >
      <div class="flex gap-[5px] items-center content-container">
        <vi-icon name="barcode" [size]="20"></vi-icon>
        <span>{{ 'GENERAL.BUTTON.SCAN' | translate }}</span>
      </div>
    </button>
    <button
      data-at-save-serial-number-modal
      mat-raised-button
      gtm="onSave"
      gtmAction="Serial number"
      gtmCategory="editSerialNumberModal"
      color="primary"
      [disabled]="!serialNumberControl.valid || !isSerialNumberChanged()"
      (click)="onSaveSerialNumber()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
